import styled from 'styled-components';

import { TOAST, TOAST_ANIM } from '../../theme/tokens';
import { contentAreaCenterX } from '../../theme/contentAreaOverlay';
import { Text } from '../Text/Text';

// Fixed layer pinned to the bottom-centre. It only lays the pill out (and never
// eats pointer events); the pill itself opts back in. z-index clears the area's
// modal backdrop (AffiliateForm = 2000) so a copy confirmation is never occluded
// by an open sheet. There is no z-index token scale in the area, so the literal is
// documented inline against that ladder.
//
// On desktop the horizontal span is constrained to the MainLayout content card
// (`contentAreaCenterX`), so the pill centres over the card instead of the
// off-centre viewport (the wide 380px Lumio column pushes the body's centre left).
export const Viewport = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  z-index: 2100;
  display: flex;
  justify-content: center;
  padding: 0 16px;
  pointer-events: none;

  ${contentAreaCenterX}
`;

// The dark pill. `$on` drives the slide-up + fade: it mounts at the offset state
// and flips to resting one frame later (the area's standard enter pattern), and
// flips back to the offset state on exit. The transition uses ENTER_MS (slower,
// softer entrance) on the way in and EXIT_MS (quicker, crisper dismissal) on the
// way out, so it settles softly and leaves promptly.
export const Pill = styled.div<{ $on: boolean }>`
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: min(420px, calc(100vw - 32px));
  padding: 14px 22px;
  border-radius: 12px;
  background: ${TOAST.bg};
  color: ${TOAST.text};
  box-shadow: ${TOAST.shadow};
  opacity: ${(p) => (p.$on ? 1 : 0)};
  transform: translateY(${(p) => (p.$on ? '0' : `${TOAST_ANIM.OFFSET_PX}px`)});
  transition: opacity ${(p) => (p.$on ? TOAST_ANIM.ENTER_MS : TOAST_ANIM.EXIT_MS)}ms ${TOAST_ANIM.EASE},
    transform ${(p) => (p.$on ? TOAST_ANIM.ENTER_MS : TOAST_ANIM.EXIT_MS)}ms ${TOAST_ANIM.EASE};
`;

export const IconWrap = styled.span`
  display: grid;
  place-items: center;
  flex: 0 0 auto;
`;

export const Message = styled(Text)`
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: ${TOAST.text};
  text-align: center;
`;
